import axios from "axios";
import { aiUserInboxUrl, aiUserMessageHistoryUrl, preProdToken } from "../constants/apis";

export const getAIUserInbox = async (page = 1) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${preProdToken}`,
        },
    };
    const response = await axios.get(`${aiUserInboxUrl}?page=${page}`, config);
    return response;
};

export const getAIUserMessageHistory = async (userId, page = 1) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${preProdToken}`,
        },
    };
    const response = await axios.get(`${aiUserMessageHistoryUrl}${userId}?page=${page}`, config);
    return response;
};
